import { IResponseProcessor } from "..";

/**
 * @deprecated This legacy API class is deprecated and will be removed.
 * For new development, please use the RTK Query hook `useGetShortsGenerationContentScenesQuery` from the `randmar-api-client`.
 */
export default class MediaApi {
  constructor(
    private _processor: IResponseProcessor,
    private _baseUrl: string = "https://api.randmar.io"
  ) { }

  public async retrieveAllScenes(): Promise<IScene[]> {
    const res = await fetch(`${this._baseUrl}/ShortsGenerationContent/Scenes`);
    this._processor.process(res);

    return res.json();
  }
}

export interface IScene {
  Name: string;
  Scene: IMediaFile;
  Thumbnail: IMediaFile;
  Preview?: IMediaFile;
  AmbientSound?: IMediaFile;
}

export interface IMediaFile {
  FileName: string;
  FileType: string;
  CreationDate: string;
  Description: string;
  ContentLength: number;
  ContentType: string;
}
